import { Dialog } from 'vant';

const BASE = {
  PICTURE_URL_PREFIX: 'https://ls2.test.cqlanhui.com/tph/',
  PAGE_SIZE: 15
};

const MSG = {
  DEFAULT_REQUEST_ERR: '网络错误',
  DEFAULT_QUERY_ERR: '获取数据失败，请重试',
  DEFAULT_OPERATE_ERR: '操作失败，请重试',
  USER_INFO_ERR: '获取用户信息失败，请重试',
  E_TICKET_LIMITED_PERIOD: '有效期以第三方平台时间为准',
  IMG_UPLOAD_ERR: '图片上传失败，请重试'
};

const DIALOG = {
  confirm(title, msg, callback, opts, onCatch) {
    Dialog.confirm(Object.assign({
      title: title,
      message: msg,
      theme: 'round-button',
      className: 'dialog-common-style'
    }, opts)).then(() => {
      callback && callback();
    }).catch(() => {
      onCatch && onCatch();
    });
  }
};

const FORMAT = {
  formatPrice(value, max = 99) {
    if (!value) {
      return '0';
    }
    if (max && Number(value) > max) {
      return max + '+';
    }
    return Number(value).toFixed(0);
  },
  formatDateTime(value, formatStr = "yyyy-MM-dd HH:mm:ss") {
    if (!value) {
      return '';
    }
    return new Date(value).format(formatStr);
  },
  formatTime(value) {
    if (!value) {
      return '';
    }
    const time = Number(value);
    const now = Date.now();
    if (now - time <= 60 * 1000) {
      return '刚刚';
    }
    const dayStart = new Date(now).floor();
    const dayEnd = new Date(now).ceil();
    if (time >= dayStart && time <= dayEnd) {
      return new Date(time).format('HH:mm');
    }
    const yearStart = new Date(now).getFirstMsecOfYear();
    const yearEnd = new Date(now).getLastMsecOfYear();
    if (time >= yearStart && time <= yearEnd) {
      return new Date(time).format('MM-DD HH:mm');
    }
    return new Date(time).format('YYYY-MM-DD');
  },
  formatUsername(name, phone) {
    if (!name && !phone) {
      return '';
    }
    if (!name) {
      name = phone;
    }
    const str = '******';
    // 手机号
    if (/^1[23456789]{1}\d{9}$/.test(name)) {
      return name.substr(0, 3) + str + name.substr(-2, 2);
    }
    if (!(/^1[23456789]{1}\d{1}\*{3,4}\d{3,4}$/.test(name))) {
      return name;
    }
    // 3/4位星号
    const arr = name.split('*');
    const pre = arr[0];
    const suf = arr[arr.length - 1];
    return pre.substr(0, 3) + str + suf.substr(-2, 2);
  },
  formatTimeStr(time, str = 'yyyy-MM-dd HH:mm') {
    if (!time) {
      return '';
    }
    return new Date(time.replace(/-/g, '/')).format(str);
  }
}

const VALIDATOR = {
  phone(value) {
    const reg = /^(1[3|4|5|6|7|8|9][0-9]{9})$/;
    return value && reg.test(value);
  }
}

export default {
  BASE,
  MSG,
  DIALOG,
  FORMAT,
  VALIDATOR
}


// WEBPACK FOOTER //
// ./src/views/carbonHuihuzhou/carbonMini/common/js/common.js